module.exports = __webpack_public_path__ + "img/9788927806615.81a06300.jpg";